function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function renderSectionBlock(sections) {
  if (!sections || sections.length === 0) {
    return '';
  }
  // 같은 PART(챕터)끼리 묶어서, PART 제목을 한 번만 보여주고 그 아래에
  // 소속 섹션들을 들여쓰기해서 나열한다.
  const groups = [];
  const groupByChapter = new Map();
  sections.forEach((s) => {
    const key = s.chapter || '';
    let group = groupByChapter.get(key);
    if (!group) {
      group = { chapter: s.chapter, items: [] };
      groupByChapter.set(key, group);
      groups.push(group);
    }
    group.items.push(s);
  });

  return groups
    .map((g, gi) => {
      const partHtml = g.chapter
        ? `<div class="part-title${gi > 0 ? ' part-gap' : ''}">${escapeHtml(g.chapter)}</div>`
        : '';
      const itemsHtml = g.items
        .map((s) => {
          const remarkHtml = s.remark
            ? `<div class="remark">${escapeHtml(s.remark).replace(/\n/g, '<br/>')}</div>`
            : '';
          return `<div class="section-line">${escapeHtml(s.sections)}</div>${remarkHtml}`;
        })
        .join('');
      return partHtml + itemsHtml;
    })
    .join('');
}

export function openLessonPlanPrint(plan) {
  // 학과/실습 시수가 모두 0인 세부교육내용도 빠지지 않도록 학과 칸에 함께 표시한다
  const theorySections = (plan.sections || []).filter((s) => s.thrytime > 0 || !(s.practime > 0));
  const practiceSections = (plan.sections || []).filter((s) => s.practime > 0);

  const html = `<!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="UTF-8" />
<title>${plan.crsyear}학년도 교수계획서 - ${escapeHtml(plan.chapter)} ${plan.unitno}차시</title>
<style>
  * { box-sizing: border-box; }
  body {
    font-family: '맑은 고딕', 'Malgun Gothic', sans-serif;
    color: #111;
    margin: 0;
    padding: 32px;
  }
  h1 {
    text-align: center;
    font-size: 26px;
    margin: 0 0 24px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  /* 인쇄 시 표가 페이지 하단 여백(20mm) 지점까지 꽉 채우도록 늘어나게 함 */
  @media print {
    body {
      padding: 0;
      min-height: 252mm; /* A4 297mm - 상단 25mm - 하단 20mm */
      display: flex;
      flex-direction: column;
    }
    table {
      flex: 1;
    }
  }
  th, td {
    border: 1px solid #000;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 1.6;
    vertical-align: middle;
    text-align: center;
  }
  thead th {
    background: #f2f2f2;
    font-weight: 700;
  }
  .summary-row td {
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .label-cell {
    font-weight: 700;
    white-space: pre-line;
    width: 16%;
  }
  .content-cell {
    text-align: left;
    vertical-align: top;
    padding: 16px 18px;
  }
  .content-heading {
    font-weight: 700;
    text-decoration: underline;
    margin-bottom: 12px;
  }
  .part-title {
    font-weight: 700;
    margin: 4px 0 6px;
  }
  .part-title.part-gap {
    margin-top: 24px;
  }
  .section-line {
    margin: 6px 0 0 20px;
  }
  .part-title + .section-line,
  .content-heading + .section-line {
    margin-top: 0;
  }
  .remark {
    margin: 4px 0 0 20px;
    color: #333;
    font-size: 13px;
    line-height: 1.6;
  }
  .print-bar {
    text-align: right;
    margin-bottom: 16px;
  }
  .print-bar button {
    background: #4f46e5;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }
  @page {
    size: A4;
    margin: 25mm 15mm 20mm 15mm;
  }
  @media print {
    .print-bar { display: none; }
  }
</style>
</head>
<body>
  <div class="print-bar">
    <button onclick="window.print()">인쇄</button>
  </div>
  <h1>${plan.crsyear}학년도 교수 계획서</h1>
  <table>
    <thead>
      <tr>
        <th style="width:12%">학년</th>
        <th style="width:14%">과 목</th>
        <th style="width:37%">교육 내용(시수)</th>
        <th style="width:10%">성 명</th>
        <th style="width:9%">차 수</th>
        <th style="width:18%">비 고</th>
      </tr>
    </thead>
    <tbody>
      <tr class="summary-row">
        <td>${escapeHtml(plan.grade)}</td>
        <td>${escapeHtml(plan.subject)}</td>
        <td>${escapeHtml(plan.chapter)}</td>
        <td>${escapeHtml(plan.teacher_name)}</td>
        <td>${escapeHtml(plan.unitno)}</td>
        <td>${escapeHtml(plan.remark)}</td>
      </tr>
      <tr>
        <td class="label-cell">학과 및 실습 전 교육${'\n'}(${plan.thrytime} 시간)</td>
        <td class="content-cell" colspan="5">
          <div class="content-heading">○ 세부교육 내용</div>
          ${renderSectionBlock(theorySections)}
        </td>
      </tr>
      <tr>
        <td class="label-cell">실 습${'\n'}(${plan.practime} 시간)</td>
        <td class="content-cell" colspan="5">
          ${practiceSections.length > 0 ? '<div class="content-heading">○ 세부교육 내용</div>' : ''}
          ${renderSectionBlock(practiceSections)}
        </td>
      </tr>
    </tbody>
  </table>
</body>
</html>`;

  const popup = window.open('', '_blank', 'width=900,height=1000');
  if (!popup) {
    alert('팝업이 차단되었습니다. 브라우저의 팝업 차단을 해제해 주세요.');
    return;
  }
  popup.document.open();
  popup.document.write(html);
  popup.document.close();
  popup.focus();
}
